import type { FavoriteAdapter } from '../favorite';

export class LocalStorageAdapter implements FavoriteAdapter {
  add(favorite: string) {
    const favorites = this.getAll();
    localStorage.setItem('favorites', JSON.stringify([...favorites, favorite]));
  }

  set(...favorites: string[]) {
    localStorage.setItem('favorites', JSON.stringify([...favorites]));
  }

  remove(favorite: string) {
    const favorites = this.getAll().filter((id) => id !== favorite);
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }

  isFavorite(id: string) {
    return this.getAll().includes(id);
  }

  getAll(): string[] {
    return JSON.parse(localStorage.getItem('favorites') || '[]');
  }
}
